/* eslint-env browser */
class EstimatedDelivery extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.renderET()
  }

  renderET() {
    fetch('/cart/async_shipping_rates.json')
        .then((response) => response.json())
        .then((response) => {
          if(response == null || response.error) {return}
          let deliveryEstimates = this.getDeliveryEstimates(response.shipping_rates);
          setCookie('deliveryEstimates', JSON.stringify(deliveryEstimates), 0.5);
          addEventListener('load', function () {
            renderETShipping();
          })
        })
  }

  init() {
    this.settings = estimatedDelivery;
    if (!this.settings.strings || !this.settings.strings.estimatedDelivery || !this.settings.strings.estimatedDeliveryWith) {
      console.error('Missing message strings for EstimatedDelivery');
      return;
    }

    this.currentLocale = Shopify.locale;
    this.estimationHolders = document.querySelectorAll('[data-delivery-estimate]');
    this.messageString = this.settings.strings.estimatedDelivery;
    this.messageWithString = this.settings.strings.estimatedDeliveryWith;
    this.shippingDateValue = this.getShippingDate();
  }

  getDeliveryEstimates(methods) {

    if (!this.shippingDateValue) {
      console.error('Missing value for this.shippingDateValue');
      return false;
    }

    const deliveryEstimates = [];
    for (const method of methods) {

      if (!this.settings.methodDays[method.code]) {
        console.error(`Method ${method.code} not found in DeliveryEstimates settings`);
        continue;
      }

      const methodDays = this.settings.methodDays[method.code];
      const methodName = method.name.split(' / ')[0];
      const deliveryMethodDate = this.getDeliveryDate(this.shippingDateValue, methodDays);
      const deliveryMethodDateFormatted = this.formatDate(deliveryMethodDate);

      const estimate = {
        deliveryDate: deliveryMethodDateFormatted,
        deliveryMethod: methodName,
      };

      deliveryEstimates.push(estimate);
    }

    return deliveryEstimates;
  }

  getShippingDate() {

    if (!this.settings.warehouse ||
        !this.settings.warehouse.timezone ||
        !this.settings.warehouse.lastShipmentTime ||
        !this.settings.warehouse.openningDays) {
      console.error('Error: missing some setting for getShippingDate');
      return false;
    }

    // Check if proper value. If not, set default
    // eslint-disable-next-line func-style
    const isWeekday = (item) => [0, 1, 2, 3, 4, 5, 6].includes(item);
    if (!Array.isArray(this.settings.warehouse.openningDays) ||
        !this.settings.warehouse.openningDays.length ||
        !this.settings.warehouse.openningDays.some(isWeekday)) {
      console.error('Error: incorrect format for openningDays');
      return false;
    }

    // Check if proper value. If not, set default
    const hourAndMinutes = this.settings.warehouse.lastShipmentTime.split(':').map((str) => parseInt(str, 10));
    if (hourAndMinutes.length !== 2 ||
        hourAndMinutes[0] > 23 || hourAndMinutes[0] < 0 ||
        hourAndMinutes[1] > 59 || hourAndMinutes[1] < 0) {
      console.error('Error: incorrect format for lastShipmentTime');
      return false;
    }

    const currentDate = new Date();
    const dateOptions = {hour: '2-digit', minute: '2-digit', timeZone: this.settings.warehouse.warehouseTimezone};
    const currentTime = currentDate.toLocaleString(this.currentLocale, dateOptions);

    // No more shipments today. Ship tomorrow the earliest
    if (currentTime > this.settings.warehouse.lastShipmentTime) {
      currentDate.setDate(currentDate.getDate() + 1);
    }

    let shipmentDate = null;
    do {
      if (this.settings.warehouse.openningDays.includes(currentDate.getDay())) {
        shipmentDate = currentDate;
      } else {
        currentDate.setDate(currentDate.getDate() + 1);
      }
    } while (!shipmentDate);

    return shipmentDate;
  }

  getDeliveryDate(shippingDate, days) {

    if (!this.settings.warehouse || !this.settings.warehouse.openningDays || !days) {
      console.error('Error: Incorrect settings for getDeliveryDate');
      return false;
    }

    const deliveryDate = new Date(shippingDate);

    let count = 0;
    while (count < days) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      if (this.settings.warehouse.openningDays.includes(deliveryDate.getDay())) {
        count++;
      }
    }
    return deliveryDate;
  }

  formatDate(date) {
    const weekDay = date.toLocaleDateString(this.currentLocale, {weekday: 'long'});
    const monthDay = date.toLocaleDateString(this.currentLocale, {day: '2-digit'});
    const monthName = date.toLocaleDateString(this.currentLocale, {month: 'long'});
    return `${weekDay} ${monthDay} ${monthName}`;
  }
}
customElements.define('estimated-delivery', EstimatedDelivery);